import { useQuery } from '@tanstack/react-query';

import { EGLD } from '../../config/sharedConfig';
import type { TokenDetails } from '../../types/token.types';
import { AshswapAggregator } from './AshswapAggregator';

const STALE_TIMES = {
  LONG: 30 * 60 * 1000, // 30 minutes
};

export const AshswapQueryKeys = {
  tokens: () => ['ashswap', 'tokens'],
  aggregation: (from: string, to: string, amount: string, slippage: number) => 
    ['ashswap', 'aggregation', from, to, amount, slippage],
};

export const useGetAshswapTokens = () => {
  return useQuery({
    queryKey: AshswapQueryKeys.tokens(),
    queryFn: async () => {
      const tokens = await AshswapAggregator.getTokens();
      const convertedTokens: TokenDetails[] = tokens.map(token => ({
        identifier: token.id,
        decimals: token.decimal ?? 1,
        price: 0,
      }));
      convertedTokens.push({
        identifier: EGLD,
        decimals: 18,
        price: 0,
      });
      return convertedTokens;
    },
    staleTime: STALE_TIMES.LONG,
  });
};